import React from "react";
import Button from "../../components/Button/Button";
import {
	faviconBlack,
	nightH,
	nightV,
	hexShapes,
	aboutBg,
	college,
} from "../../utils/images";
import "./home.scss";

const Home = () => {
	return (
		<main className="home">
			<section
				className="home-hero"
				style={{
					backgroundImage: `url(${
						window.innerWidth > window.innerHeight ? nightH : nightV
					})`,
				}}
			>
				<div className="night">
					{Array(20)
						.fill(1)
						.map((ele, id) => (
							<div key={id} className="shooting_star"></div>
						))}
				</div>
				<div className="home-hero-icon">
					<img src={faviconBlack} alt="icon" data-aos="zoom-in" />
				</div>
				<div className="home-hero-text">
					<h2>Event Planning and Management Council</h2>
					<span>Indian Institute of Information Technology, Una</span>
				</div>
				<div className="home-hero-empty"></div>
			</section>
			<section
				className="home-about"
				style={{
					backgroundImage: `url(${aboutBg})`,
				}}
			>
				<div className="home-about-text">
					<h2>About Us</h2>
					<p>
						This club focuses on the cultural development of the
						institute as well as bringing the institute to the
						outside world. Engineering colleges, be it IITs, NITs,
						or other IIITs are known for their placements and
						cultural footprints, we want to work on both for the
						all-round development of the institute.
					</p>
					<div className="home-about-buttons">
						<Button
							text="Know More"
							link="/about"
							color="white"
							icon="north_east"
						/>
						<Button
							text="Contact Us"
							link="/contact"
							color="black"
							icon="phone"
						/>
					</div>
				</div>
			</section>
			<section
				className="home-quote"
				style={{
					height: "auto",
					backgroundImage: `url(${college})`,
				}}
			>
				<div className="home-quote-wrapper">
					<blockquote>
						<p>
							If everyone is moving forward together, then success
							takes care of itself.
						</p>
						<cite> - Henry Ford</cite>
					</blockquote>
				</div>
			</section>
			<section
				className="home-apply"
				style={{
					backgroundImage: `url(${hexShapes})`,
				}}
			>
				<h2>Join EPMOC</h2>
				<p>
					We are looking for people who are passionate about
					organizing events and have a knack for management. Apply now
					to be a part of the team.
				</p>
				<div className="home-apply-buttons">
					<Button
						text="Apply Now"
						color="white"
						link="/forms/apply"
						icon="north_east"
					/>
				</div>
			</section>
		</main>
	);
};

export default Home;
